import axiosPrivate from "./axiosPrivate"

export const getFacebookBusinessManagerId = async () => {
  return axiosPrivate.get(`me/businesses`)
}
